<template>
  <svg viewBox="0 0 46 46" style="height: 1rem; transform: scale(1.5); margin-left: -0.1rem; margin-right: 0.1rem">
    <path
      fill="currentColor"
      d="m 29,35.900001 c 0,-0.1 0,-0.3 0,-0.4 0,-0.7 0.1,-1.2 0.1,-1.4 0,-0.5 0.8,-5.6 1,-6.7 0.2,-1.1 -0.2,-1.4 -0.2,-1.4 0.4,-3 0.2,-6.1 -0.7,-9 0.5,-0.4 -0.6,-2.7 -0.6,-2.7 -0.8,-1.9 -1.7,-4.6000011 -1.7,-4.6000011 v 0 c -0.2,-0.6 -0.4,-1.5 -0.5,-2.5 -0.1,-1.5 -0.1,-3 -0.1,-3.5 0,-0.5 0.5,-0.4 0.5,-0.7 -0.1,-0.5 -0.3,-1 -0.5,-1.5 0,-0.1 0,-0.2 0,-0.3 0,-0.1 0.1,-0.1 0.1,-0.19999995 C 26.4,0.50000001 25.9,0 25.4,0 c 0,0 0,0 0,0 h -4.3 c -0.5,0 -0.9,0.40000001 -0.9,0.90000001 0,0 0,0 0,0 0.1,0.1 0.1,0.1 0.1,0.19999989 0,0.1 0,0.2 0,0.3 -0.1,0.6 -0.3,1.1 -0.4,1.6 0,0.3 0.5,0.3 0.5,0.7 0,0.4 0,2 -0.1,3.5 -0.2,1 -0.4,1.9 -0.5,2.5 v 0 c 0,0 -1,2.7000011 -1.8,4.6000011 0,0 -1.1,2.3 -0.6,2.7 -0.9,2.9 -1.1,6 -0.7,9 0,0 -0.3,0.3 -0.2,1.4 0.1,1.1 1,6.2 1,6.7 0,0.2 0.1,0.7 0.1,1.4 v 0.5 c 0,3.1 -1.3,4.6 -1.3,6.6 0,2.7 1.7,4 7,4 5.3,0 7,-1.4 7,-4 0,-2 -1.3,-3.5 -1.3,-6.6"
    ></path>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
